<template>
  <div class="page-head">
    <div class="container-fluid">
      <div class="page-title">
        <h1>
          {{ this.title }}
          <small>{{ this.subtitle }}</small>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, required: false }
  }
};
</script>
